import { render, staticRenderFns } from "./PhysioDetailsView.vue?vue&type=template&id=5d53e68a"
import script from "./PhysioDetailsView.vue?vue&type=script&lang=js"
export * from "./PhysioDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports